if (!customElements.get('back-in-stock')) {
  customElements.define('back-in-stock', class BackInStock extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.notify = document.querySelector('.notify');
      this.action = this.form.getAttribute('action');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      fetch(this.action, {
        method: 'POST',
        headers: {
          accept: 'application/json',
          revision: '2024-06-15',
          'content-type': 'application/json'
        },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: this.querySelector('[name="email"]').value
                  }
                }
              }
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${this.querySelector('[name="variant"]').value}`
                }
              }
            }
          }
        }),
      })
      .then((response) => {
        if(response.status === 202) {
          this.notify.classList.add('notify--success');
        }
      })
      .catch((e) => {
        console.log(e);
      });
    }
  });
}
